import { SEX } from "./status";

export default {
  INCOMELEVEL:'incomeLevel', // Monthly income
  AMOUNT_TYPE: 'amounttype', // Basic amount type
  ORDER_STATUS2: 'orderstatus2',
  FEE_AMOUNT_DETAIL_JUNCTURE: 'fee_amount_detail_juncture',//Investment platform revenue node
  RELATIONSHIP: 'relationship', // Contact relationship
  ORDER_STATUS: 'orderstatus', // Order status
  BANK: 'bank', // Bank name
  REALTIONSHIP: 'secrelationship', // Contact relationship
  SEC_RELATIONSHIP: 'secrelationship', // Other contact relationship
  MARITAL_STATUS: 'maritalstatus', // Marital status
  EDUCATION: 'education', // Education level
  WORK_TYPE: 'worktype', // Work type
  ACCMMODATION_TYPE: 'accommodationtype', // Housing type
  POSITION: 'position', // Position
  LOAN_STATUS: 'loanstatus', // Loan status
  OVERDUE_STATUS: 'overduestatus', // Overdue status
  PAY_METHED: 'paymethed', // Salary payment method
  WORK_YEARS: 'workyears', // Work years
  PROFESSION: 'profession', // Work industry
  DESIGNATION: 'designation', // Work position
  ORDER_TYPE: 'ordertype', // Order type
  SETTLE_STATUS: 'settlestatus', // Settlement status
  PART_STATUS: 'partstatus', // Settlement status
  INSTALLMENT_SETTLE_STATUS: 'installmentsettlestatus', // Installment order settlement status
  APPROVAL_TASK_STATUS: 'approvetaskstatus', // Task status
  APPROVAL_STATUS: 'approvestatus', // Review status
  FOLLOW_RESULT: 'followresult', // Follow-up result
  REAPYMENT_INTENTION: 'repaymentintention', // Repayment willingness
  COLLECTION_TASK_STATUS: 'collectiontaskstatus', // Collection task status
  COLLECTION_TYPE: 'collectiontype', //Wallet type
  COLLECTION_TRADE_NEW_TYPE: 'collectiontradenewtype', //For collection use COLLECTION_TYPE
  ALLOW_DIFER_TIME: 'allowdifertime', //Allowed extension time
  PRODICT_CONFIG_TYPE: 'prodictconfigtype',
  REPAYMENT_METHOD: 'repaymentmethod',
  LOAN_PURPOSE: 'loanpurpose', //Loan purpose
  REMIND_TASK_STATUS: 'remindtaskstatus', //Loan purpose
  MONTHLY_INCOME: 'monthlyincom',
  CONTACT_RESULT: 'contactresult',//Reminder management-Follow-up result
  COLLECTOR_TYPE: 'collectortype',//Collection type
  CUST_CONTRACT_CONDITION: 'custcontractcondition', // Follow-up result
  LINKCONDITION: 'linkcondition', // Address book and contact info
  BANKACCOUNT_TYPE: 'bankaccounttype',// Bank card type
  BANKNAMELIST: 'banknamelist',//Collection type
  BANKLISTF: 'banklistf',
  questionType: 'questiontype',
  complainType: 'complaintype',
  STAGE_TYPE: 'stagetype',  // Installment type
  GROUP_LEVEL: 'grouplevel',  // Collection case assignment level
  repayCertWorkOrderStatus: 'repaycertworkorderstatus',
  INVEST_ASSET_STATUS: 'investAssetStatus',
  INVEST_ORDER_STATUS: 'investOrderStatus',
  COLLECTOR_COUNTRY: 'collectorcountry',
  NO: 'no',
  SEX: 'sex',
  PLATFORMFEENAMELIST: 'platfromfeenamelist',
  PLATFORMFEEPOINT: 'platformfeepoint',
}
